<template>
    <div style="background-color: white" class="d-flex align-items-center justify-content-center">
        <div class="d-flex flex-column align-items-center justify-content-center;">
            <!-- TITLE -->
            <div class="mb-4">
                <h2>{{ $t("s_wholesaler_login_title") }}</h2>
            </div>

            <!-- INTRO -->
            <div class="mb-4 col-12 mb-3 alert alert-secondary text-left" v-html="$t('s_wholesaler_intro')">
            </div>

            <!-- CONTACT OPTIONS-->
            <div class="mb-4 col-12 mb-3 alert alert-secondary text-left">
                <div v-html="$t('s_wholesaler_access_details')"></div>
                <!-- <p>{{ $t("s_wholesaler_contact_title") }}</p>
                <ul>
                    <li>{{ $t("s_wholesaler_login") }}</li>
                    <li>{{ $t("s_wholesaler_register") }}</li>
                    <li v-if="app.WholeSaler.allowGuest">{{ $t("s_wholesaler_guest") }}</li>
                </ul> -->
                <!-- BUTTONS -->
                <div class="col-12 d-flex justify-content-center">
                    <button class="btn btn-primary loginButton mr-3" @click="app.auth.login()">
                        {{ $t("login") }}
                    </button>
                    <!-- <button class="btn btn-primary loginButton mr-3" @click="app.auth.register()">
                        {{ $t("register") }}
                    </button> -->
                    <button class="btn btn-primary loginButton" @click="app.WholeSaler.showGuestForm()"
                        v-if="app.WholeSaler.allowGuest">
                        {{ $t("s_wholesaler_guest_button") }}
                    </button>
                </div>
            </div>




        </div>
    </div>
</template>

<script>
import { app } from "../application.js";

export default {
    name: "wholesalerMustLoginComponent",
    data() {
        return {
            app: app
        };
    },
    mounted() {
        var self = this

        //hide navigationbar
        this.app.showNavigationBar = false;

        if (this.app.WholeSaler.isAuthorized == true) {
            this.app.routerPush('1')
        }
        // window.Unex.Authentication.on('login', function () {
        //     self.app.routerPush('1')
        // });
    },
    watch: {
        'app.WholeSaler.isAuthorized'(newValue) {
            if (newValue == true) {
                this.app.routerPush('1')
            }
        }
    },
    methods: {
    },
};
</script>

<style lang="scss">
#app {
    padding-bottom: 0;
}

.content_app {
    margin-bottom: 0px !important;
}
</style>
